<template>
  <div class="boxes-bg" v-if="isVisible">
    <div class="boxes">
      <div class="box" v-for="n in 4" :key="n">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreloaderComponent",
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped></style>
